import { useEffect } from 'react';
import mitt, { Handler } from 'mitt';
import { GetWebsocketEventPayload, WebsocketEventMethods } from './events';

export type GetWebsocketEventHandler<T extends WebsocketEventMethods> = Handler<GetWebsocketEventPayload<T>>;
export type WebsocketEvents = {
  [K in WebsocketEventMethods]: GetWebsocketEventPayload<K>;
};

/**
 * @internal
 * Don't use this directly, use the useWebsocketEventPublisher to get access to the publisher
 */
export const internal_Publisher = mitt<WebsocketEvents>();

/**
 * This is a specifically made pubsub for the weave websocket events. An improved version of this might ingest the publisher/emitter,
 * rather than hard coding it here, but this hard-coded version should work well for the first iteration
 */
export const useWebsocketEventSubscription = <T extends WebsocketEventMethods, H extends GetWebsocketEventHandler<T>>(
  event: T,
  handler: H
) => {
  useEffect(() => {
    internal_Publisher.on(event, handler);
    return () => {
      internal_Publisher.off(event, handler);
    };
  }, [handler, event]);
  return {
    internal_Publisher,
    event,
  };
};

export const useWebsocketEventPublisher = () => {
  return internal_Publisher;
};
